import Phaser from "phaser";

export default class VfxSprite extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, texture, repeat, options = {}) {
        super(scene, x, y, texture);
        
        // Set sprite initially as invisible
        this.setVisible(false);

        this.texture = texture;
        this.direction = options.direction || 1;
        this.scale = options.scale;
        
        // Set default frames with texture-specific overrides
        let maxFrames = 16; // Default maximum
        
        // Texture-specific frame counts
        const textureFrameCounts = {
            'star_burst': 4,           // Star burst has only 4 frames
            'blue_light_burst': 64,    // Blue light burst has 64 frames
            'blue_light_flash': 4,     // Add blue_light_flash with the correct frame count (appears to be 4)
            // Add other textures with specific frame counts as needed
        };
        
        // Use texture-specific count if available
        if (textureFrameCounts[texture]) {
            maxFrames = textureFrameCounts[texture];
        }
        
        // Use provided frames or texture-specific maximum
        this.frames = options.frames ? Math.min(options.frames, maxFrames) : maxFrames;
        this.delay = options.delay || 0;
        this.speed = Math.random() * 4 + 1;
        
        const animKey = texture + '-vfx';
        
        // Check if animation already exists before creating it
        if (!this.scene.anims.exists(animKey)) {
            this.scene.anims.create({
                key: animKey,
                frames: this.scene.anims.generateFrameNumbers(texture, { 
                    start: 0, 
                    end: this.frames - 1 // Subtract 1 because frames are 0-indexed
                }),
                frameRate: 30,
                repeat: repeat
            });
        }

        // Play the animation
        if (this.delay > 0) {
            this.scene.time.delayedCall(this.delay, () => {
                this.setVisible(true);
                this.play(animKey);
            });
        } else {
            this.setVisible(true);
            this.play(animKey);
        }

        this.on('animationcomplete', function () {
            this.destroy();
        }, this);

        scene.add.existing(this);
    }

    update() {
        if (this.texture.key === 'shockwave' || 
            this.texture.key === 'firework' || 
            this.texture.key === 'white_light_flash' || 
            this.texture.key === 'blue_light_flash' ||
            this.texture.key === 'star_burst') {
                return;
        }
        this.x += this.speed * this.direction;

        if (this.x > this.scene.sys.game.config.width && this.direction === 1) {
            this.direction = -1;
        } else if (this.x < 0 && this.direction === -1) {
            this.direction = 1;
        }
    }
}